/**
 * Helper centralizzato per costruire URL autenticate verso /api/uploads/*.
 * Aggiunge automaticamente il JWT come query param ?t=... per compatibilità
 * con <img src=...> e <a href=...> diretti (i browser non inviano l'header
 * Authorization su questi tag).
 *
 * Uso:
 *   import { fileUrl } from "../lib/fileUrl";
 *   <img src={fileUrl(item.immagine_path)} />
 *   <a href={fileUrl(doc.file_url)} download>...</a>
 */
const BACKEND = process.env.REACT_APP_BACKEND_URL;
if (!BACKEND) throw new Error("REACT_APP_BACKEND_URL non configurato");

export function fileUrl(path) {
  if (!path) return "";
  // Se l'URL è già assoluto verso CDN esterna, lascialo intatto
  if (/^https?:\/\//i.test(path)) return path;

  const token = (typeof window !== "undefined" && window.localStorage)
    ? (window.localStorage.getItem("token") || window.localStorage.getItem("sa_token") || "")
    : "";

  // Il vecchio /uploads/ non passa dal proxy /api su tutti i domini: mantieni
  // il riferimento originale nel DB, ma servi il file dalla rotta protetta.
  const normalized = path.startsWith("/uploads/") ? `/api${path}`
    : path.startsWith("uploads/") ? `/api/${path}`
    : path.startsWith("api/uploads/") ? `/${path}`
    : path.startsWith("/") ? path : `/${path}`;
  const base = `${BACKEND}${normalized}`;

  if (!token) return base;
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}t=${encodeURIComponent(token)}`;
}

// URL della miniatura leggera (per anteprime veloci). Deriva il path _thumb.webp.
export function thumbUrl(path) {
  if (!path || !path.endsWith(".webp")) return fileUrl(path);
  return fileUrl(path.replace(/\.webp$/, "_thumb.webp"));
}

export default fileUrl;
